import { Schema as S } from "effect";
export const Schema = S.String.pipe(S.brand("@open-revenue/schema/SubscriptionId"), S.annotations({
    description: "A unique identifier for a subscription. Usually provided by stripe"
}));
export const Type = Schema.Type;
export const make = (id)=>S.decodeUnknown(Schema)(id);
export const makeUnsafe = (id)=>id;
